// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1Colr","actions":"GroupTable_actions__UZl5F","deleteModalFooter":"GroupTable_deleteModalFooter__2mHmp"};